import { keepPreviousData } from '@tanstack/vue-query';
import { nanoid } from 'nanoid';

const session_token = nanoid();

export function useAddressSearch(searchTerm: Ref<string | undefined>) {
  const { locale } = useI18n();
  const enabled = computed(() => !!searchTerm.value);
  // Search near browser geolocation to improve results
  const { coords } = useGeolocation();

  return useQuery({
    queryKey: [`ADDRESS_SEARCH`, searchTerm],
    placeholderData: keepPreviousData,
    queryFn: () => {
      const query = {
        searchTerm: searchTerm.value,
        sessionToken: session_token,
        language: locale.value,
        // can have “Infinite” values
        latitude: Number.isFinite(coords.value?.latitude) ? coords.value?.latitude : undefined,
        longitude: Number.isFinite(coords.value?.longitude) ? coords.value?.longitude : undefined,
      };
      return $fetch('/api/address', { query });
    },
    enabled,
  });
}

export function useImperativeAddressRetrieve() {
  const { locale } = useI18n();

  return useMutation({
    mutationFn: (id: string) => {
      const query = {
        id,
        sessionToken: session_token,
        language: locale.value,
      };
      return $fetch('/api/address/retrieve', { query });
    },
  });
}
